import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, Observable, throwError, timeout } from 'rxjs';
import { ApiResponse } from '../models/api-response.model';
import { RegisteredRetailers } from '../models/registered-retailers.model';
import { RetailerFilter } from '../models/retailer-filters.model';
import { AddUpdateRetailer } from '../models/add-retailer.model';
import { GeneratePresignedUrlModel, GeneratePresignedUrlResModel } from '../models/generate-presigned-url.model';
import { LocationResponse } from '../models/location.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RetailerService {

  constructor(private http: HttpClient) {}
  private apiTimeout = 15000;
  getRetailers(pageIndex: number, pageSize: number, filters: RetailerFilter = {}): Observable<ApiResponse<RegisteredRetailers>> {
    const params = new HttpParams({
      fromObject: {
        pageOffset: pageIndex,
        pageLimit: pageSize,
        ...filters
      },
    });

    return this.http.get<ApiResponse<RegisteredRetailers>>(`${environment.baseUrlUserService}/v1/field-officer/retailers`, { params });
  }

  createOrUpdateRetailer(retailer: AddUpdateRetailer): Observable<ApiResponse<any>> {
    return this.http.put<ApiResponse<any>>(`${environment.baseUrlUserService}/v1/field-officer/retailer`, retailer);
  }

  getPresignedUrl(payload: GeneratePresignedUrlModel): Observable<ApiResponse<GeneratePresignedUrlResModel[]>> {
    return this.http.post<ApiResponse<GeneratePresignedUrlResModel[]>>(`${environment.baseUrlUserService}/v1/generate_presign_url`, payload);
  }

  uploadFileToS3(s3Url: string, file: File): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': file.type
    });
    return this.http.put(s3Url, file, { headers: headers }).pipe(
      timeout(this.apiTimeout), // Apply the timeout here
      catchError(error => {
        if (error.name === 'TimeoutError') {
          console.error('RetailerService: uploadFileToS3 timed out!', error);
          // You can throw a custom error or just the original timeout error
          return throwError(() => new Error('Upload timed out. Please check your internet connection and try again.'));
        }
        // Re-throw other errors
        return throwError(() => error);
      })
    );
  }

  getFieldOfficerLocation(latitude: number, longitude: number): Observable<ApiResponse<LocationResponse>> {
    const headers = new HttpHeaders({ latitude, longitude });
    return this.http.get<ApiResponse<LocationResponse>>(`${environment.baseUrlUserService}/v1/field-officer/retailer/location`, { headers });
  }
}
